










import { listFactory } from '@/main/pages';
import { Typ } from '@/modules/ciselnik/dilenske/typ';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		TypSelect: Typ.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				typKod: `${this.storeUri}/${listMutations.OJETE_VOZY_TYP_KOD_FILTER_SELECT_MAPPER}`,
			};
		},
		typkodFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
	},
});
